<template>
  <van-popup
    round
    v-model="visible"
    closeable
    position="bottom"
    @close="closeFun"
  >
    <div class="dc_0">
      <!-- <div>取货二维码（<span class="red">{{info.itemsCount}}</span>件商品）</div> -->
      <div class="dc_1 mar-t">
        <div class="dc_3">
          <van-image
            width="250"
            height="350"
            fit="cover"
            :src="info.codeImageUrl"
          />
        </div>
        <!-- <p class="dc_4">支持店铺后台填入取货码</p>
      <p class="dc_4">完成科传系统入机</p> -->
      </div>
      <div>
        <!-- <div @click="savePringCodeFun" class="dc_2">
          <van-image
            round
            width="55"
            height="55"
            fit="cover"
            :src="pdownIncon"
          />
        </div> -->
        <p class="save_btn" @click="savePringCodeFun">保存图片</p>
      </div>
      <div class="foot_box">
        <van-button class="btn" @click="jump">同步至科传</van-button>
        <div class="tip_text">可直接同步订单到科传系统入机</div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import Util from "@/utils/common";
import http from "@/utils/axios";
export default {
  name: "",
  props: {},
  data() {
    return {
      pdownIncon: require("@/assets/image/cdown.png"),
      visible: false,
      info: {},
      subId: "",
    };
  },
  methods: {
    savePringCodeFun() {
      Util.nativeMethod({
        tm: "3050001",
        tp: { urls: [this.info.codeImageUrl] },
      });
    },
    init() {
      http({
        url: "order/express/generateFamiliesPassCode/" + this.subId,
        method: "GET",
      })
        .then((rps) => {
          this.info = rps.data;
          this.visible = true;
        })
        .catch((rps) => {});
    },
    closeFun() {
      this.$emit("callback");
    },
    jump() {
      this.$router.push({
        path: "/beeSameMachine",
        query: { subId: this.subId, code: this.info.familiesPassCodeNo },
      });
    },
  },
  created() {},
  watch: {},
  destroyed() {},
  mounted() {},
  components: {},
};
</script>
<style lang="less" scoped>
.dc_0 {
  font-size: 24px;
  margin: 0 auto;
  color: #333333;
  text-align: center;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .mar-t {
    margin-top: 117px;
  }
  .mar-t2 {
    margin-top: 10px;
  }
  .dc_1 {
    width: 530px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    padding: 30px;
  }
  .dc_4 {
    color: #999999;
  }
  .dc_2 {
    width: 280px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .save_btn {
    width: 160px;
    height: 60px;
    background: #ffffff;
    border-radius: 32px;
    border: 1px solid #999999;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 60px;
    margin: 30px 0 23px 0;
  }
  .text {
    p {
      font-size: 32px;
    }
  }
  .ml20 {
    margin-left: 20px;
  }
  .org {
    color: #f8a651;
    font-weight: bold;
  }
  .red {
    color: #ed3939;
    font-weight: bold;
  }
}
.foot_box {
  height: 173px;
  background-color: #fff;
  width: 100%;
  .btn {
    width: 690px;
    height: 80px;
    background: var(--epButtonColor);
    color: var(--epTextColor);
    border-radius: 40px;
    font-size: 24px;
    text-align: center;
    margin: 10px 0;
  }
  .tip_text {
    width: 100%;
    height: 73px;
    line-height: 73px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: center;
    border-top: 1px solid #f4f4f4;
  }
}
</style>
